<div class="p-6">
  <!-- Toast de éxito -->
  <div *ngIf="showSuccessToast" 
       class="fixed top-4 right-4 z-50 animate-fade-in-down">
    <div class="bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-3">
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
      </svg>
      <span class="font-medium">{{ successMessage }}</span>
    </div>
  </div>

  <!-- Header -->
  <div class="mb-6">
    <h2 class="text-2xl font-bold text-gray-900 mb-2">Gestor de Transiciones de Estado</h2>
    <p class="text-gray-600">Configura cómo los alumnos avanzan entre estados según eventos del sistema</p>
  </div>

  <!-- Controles -->
  <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
    <div class="flex items-center justify-between mb-6">
      <div class="flex gap-2">
        <button
          (click)="viewMode = 'flow'"
          [class.bg-primary]="viewMode === 'flow'"
          [class.text-white]="viewMode === 'flow'"
          [class.bg-gray-100]="viewMode !== 'flow'"
          [class.text-gray-700]="viewMode !== 'flow'"
          class="px-4 py-2 rounded-lg font-medium transition-colors hover:bg-primary hover:text-white">
          Vista de Flujo
        </button>
        <button
          (click)="viewMode = 'list'"
          [class.bg-primary]="viewMode === 'list'"
          [class.text-white]="viewMode === 'list'"
          [class.bg-gray-100]="viewMode !== 'list'"
          [class.text-gray-700]="viewMode !== 'list'"
          class="px-4 py-2 rounded-lg font-medium transition-colors hover:bg-primary hover:text-white">
          Vista de Árbol
        </button>
      </div>
      <div class="flex gap-3">
        <button 
          (click)="openCopyForm()" 
          class="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
          </svg>
          Copiar de otro producto
        </button>
        <button 
          (click)="openCreateForm()" 
          class="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
          </svg>
          Nueva Transición
        </button>
      </div>
    </div>

  <!-- Leyenda -->
    <h3 class="font-semibold mb-3 text-gray-900">Leyenda</h3>
    <div class="flex flex-wrap gap-4 text-sm">
      <div class="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-green-600" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
        </svg>
        <span>Transición exitosa (aprobado)</span>
      </div>
      <div class="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-red-600" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
        </svg>
        <span>Transición de fallo (suspendido/caducado)</span>
      </div>
      <div class="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
        </svg>
        <span>Transición normal</span>
      </div>
      <div class="flex items-center gap-2">
        <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-amber-100 text-amber-800">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
          Disparador
        </span>
      </div>
      <div class="flex items-center gap-2">
        <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
          </svg>
          Condición
        </span>
      </div>
      <div class="flex items-center gap-2">
        <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
          </svg>
          Acción
        </span>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="text-center py-12">
    <div class="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
    <p class="mt-4 text-gray-600">Cargando transiciones...</p>
  </div>

  <!-- Error -->
  <div *ngIf="error && !loading" class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">
    {{ error }}
  </div>

  <!-- Vista de Flujo -->
  <div *ngIf="!loading && !error && transitions.length > 0 && viewMode === 'flow'" class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
    <div class="space-y-4">
      
      <!-- Transiciones iniciales (sin estado origen) -->
      <ng-container *ngIf="getTransitionsFrom(null).length > 0">
        <div class="relative">
          <!-- Estado inicial -->
          <div class="bg-gray-100 border-gray-300 border-2 rounded-lg p-4">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-3">
                <span class="font-semibold text-gray-800">Cualquier estado</span>
              </div>
            </div>
          </div>

          <!-- Transiciones desde estado inicial -->
          <div class="ml-8 mt-2 space-y-2">
            <div *ngFor="let transition of getTransitionsFrom(null)" class="flex items-start gap-2">
              <div class="flex-1">
                <div 
                  [ngClass]="{
                    'border-green-400': isTransitionSuccess(transition) === true,
                    'border-red-400': isTransitionSuccess(transition) === false,
                    'border-gray-300': isTransitionSuccess(transition) === null
                  }"
                  class="flex items-center gap-2 p-3 bg-white border-2 rounded-lg">
                  <!-- Icono según tipo de transición -->
                  <svg *ngIf="isTransitionSuccess(transition) === true" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-green-600 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                  </svg>
                  <svg *ngIf="isTransitionSuccess(transition) === false" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-red-600 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                  </svg>
                  <svg *ngIf="isTransitionSuccess(transition) === null" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-600 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                  
                  <!-- Información de la transición -->
                  <div class="flex-1">
                    <div class="flex flex-wrap items-center gap-1.5">
                      <!-- Badge de disparador -->
                      <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-amber-100 text-amber-800">
                        <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                        {{ transition.trigger_event_label }}
                      </span>
                      <!-- Badges de condiciones -->
                      <ng-container *ngIf="(transition.condition_definitions || transition.conditionDefinitions)?.length > 0">
                        <span *ngFor="let condition of (transition.condition_definitions || transition.conditionDefinitions)"
                              class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                          <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                          </svg>
                          {{ condition.name }}
                        </span>
                      </ng-container>
                      <!-- Badges de acciones -->
                      <ng-container *ngIf="(transition.action_definitions || transition.actionDefinitions)?.length > 0">
                        <span *ngFor="let action of (transition.action_definitions || transition.actionDefinitions)"
                              class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800">
                          <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                          </svg>
                          {{ getRateNameForAction(transition, action) }}
                        </span>
                      </ng-container>
                    </div>
                  </div>

                  <!-- Flecha -->
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>

                  <!-- Estado destino -->
                  <div [ngClass]="getStateColor(transition.to_state?.id)" class="px-3 py-1 rounded text-sm font-medium border">
                    {{ transition.to_state?.name }}
                  </div>

                  <!-- Acciones -->
                  <button (click)="openEditForm(transition)" class="p-1 hover:bg-gray-100 rounded" title="Editar">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                    </svg>
                  </button>
                  <button (click)="deleteTransition(transition.id)" class="p-1 hover:bg-gray-100 rounded text-red-600" title="Eliminar">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Línea conectora -->
          <div class="h-4 w-0.5 bg-gray-300 ml-4 my-1"></div>
        </div>
      </ng-container>

      <!-- Estados normales -->
      <ng-container *ngFor="let state of allStates; let i = index">
        <div class="relative">
          <!-- Estado actual -->
          <div 
            [ngClass]="{
              'ring-2 ring-blue-400 ring-offset-2 scale-105': isStateDraggedOver(state),
              'opacity-50': draggedState?.id === state.id,
              'pointer-events-none': isReordering,
              'cursor-grabbing': draggedState?.id === state.id
            }"
            class="transition-all duration-200 ease-in-out"
            draggable="true"
            (dragstart)="onStateDragStart($event, state)"
            (dragover)="onStateDragOver($event, state)"
            (dragleave)="onStateDragLeave($event)"
            (drop)="onStateDrop($event, state)"
            (dragend)="onStateDragEnd($event)">
            <div 
              [ngClass]="getStateColor(state.id)"
              class="border-2 rounded-lg p-4 cursor-grab hover:shadow-lg transition-all duration-200">
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-3">
                  <!-- Icono de drag handle -->
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-gray-400 hover:text-gray-600 transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h16M4 16h16" />
                  </svg>
                  <span class="font-semibold text-gray-800">{{ state.name }}</span>
                  
                  <!-- Badge de número de transiciones -->
                  <span class="ml-2 px-2 py-0.5 text-xs font-medium bg-gray-100 text-gray-600 rounded-full">
                    {{ getTransitionsFrom(state.id).length }} transiciones
                  </span>
                </div>
                <div class="flex gap-2">
                  <!-- Botón para añadir transición -->
                  <button 
                    (click)="openCreateTransitionModal(state); $event.stopPropagation()"
                    class="flex items-center justify-center w-8 h-8 text-black group pointer-events-auto"
                    title="Añadir transición desde {{ state.name }}"
                    draggable="false">
                    <svg class="w-5 h-5 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
                    </svg>
                  </button>
                  
                  <!-- Indicador de reordenando -->
                  <div *ngIf="isReordering" class="flex items-center gap-2 text-blue-600 text-sm">
                    <svg class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <span>Guardando...</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Transiciones salientes -->
          <ng-container *ngIf="getTransitionsFrom(state.id).length > 0">
            <div class="ml-8 mt-2 space-y-2">
              <div *ngFor="let transition of getTransitionsFrom(state.id)" class="flex items-start gap-2">
                <div class="flex-1">
                  <div 
                    [ngClass]="{
                      'border-green-400': isTransitionSuccess(transition) === true,
                      'border-red-400': isTransitionSuccess(transition) === false,
                      'border-gray-300': isTransitionSuccess(transition) === null
                    }"
                    class="flex items-center gap-2 p-3 bg-white border-2 rounded-lg">
                    <!-- Icono según tipo de transición -->
                    <svg *ngIf="isTransitionSuccess(transition) === true" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-green-600 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                    <svg *ngIf="isTransitionSuccess(transition) === false" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-red-600 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                    </svg>
                    <svg *ngIf="isTransitionSuccess(transition) === null" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-600 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                    
                    <!-- Información de la transición -->
                    <div class="flex-1">
                      <div class="flex flex-wrap items-center gap-1.5">
                        <!-- Badge de disparador -->
                        <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-amber-100 text-amber-800">
                          <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                          </svg>
                          {{ transition.trigger_event_label }}
                        </span>
                        <!-- Badges de condiciones -->
                        <ng-container *ngIf="(transition.condition_definitions || transition.conditionDefinitions)?.length > 0">
                          <span *ngFor="let condition of (transition.condition_definitions || transition.conditionDefinitions)"
                                class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                            </svg>
                            {{ condition.name }}
                          </span>
                        </ng-container>
                        <!-- Badges de acciones -->
                        <ng-container *ngIf="(transition.action_definitions || transition.actionDefinitions)?.length > 0">
                          <span *ngFor="let action of (transition.action_definitions || transition.actionDefinitions)"
                                class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800">
                            <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                            </svg>
                            {{ getRateNameForAction(transition, action) }}
                          </span>
                        </ng-container>
                      </div>
                    </div>

                    <!-- Flecha -->
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>

                    <!-- Estado destino -->
                    <div [ngClass]="getStateColor(transition.to_state?.id)" class="px-3 py-1 rounded text-sm font-medium border">
                      {{ transition.to_state?.name }}
                    </div>

                    <!-- Acciones -->
                    <button (click)="openEditForm(transition)" class="p-1 hover:bg-gray-100 rounded" title="Editar">
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                      </svg>
                    </button>
                    <button (click)="deleteTransition(transition.id)" class="p-1 hover:bg-gray-100 rounded text-red-600" title="Eliminar">
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Línea conectora al siguiente estado -->
          <div *ngIf="i < allStates.length - 1" class="h-4 w-0.5 bg-gray-300 ml-4 my-1"></div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Vista de Árbol -->
  <div *ngIf="!loading && !error && transitions.length > 0 && viewMode === 'list'" class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
    <div class="space-y-2">
      
      <!-- Estado inicial (transiciones sin from_state) -->
      <div *ngIf="getTransitionsFrom(null).length > 0" class="border rounded-lg overflow-hidden">
        <!-- Encabezado del estado inicial -->
        <div 
          class="bg-gray-100 border-gray-300 border-b-2 p-3 cursor-pointer hover:opacity-80 transition-opacity"
          (click)="toggleExpanded(0)">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-2">
              <!-- Icono de expandir/colapsar -->
              <svg *ngIf="!expandedStates[0]" 
                xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
              </svg>
              <svg *ngIf="expandedStates[0]" 
                xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
              
              <span class="font-semibold">Estado Inicial</span>
              
              <!-- Badge con número de transiciones -->
              <span class="text-xs bg-white px-2 py-1 rounded-full">
                {{ getTransitionsFrom(null).length }} transición{{ getTransitionsFrom(null).length !== 1 ? 'es' : '' }}
              </span>
            </div>
          </div>
        </div>

        <!-- Transiciones iniciales (colapsable) -->
        <div *ngIf="expandedStates[0]" class="p-3 bg-gray-50 space-y-2">
          <div *ngFor="let transition of getTransitionsFrom(null)"
            class="bg-white border rounded-lg p-3 hover:shadow-sm transition-shadow">
            <div class="flex items-start justify-between gap-3">
              <div class="flex-1">
                <!-- Título con icono de estado -->
                <div class="flex items-center gap-2 mb-2">
                  <svg *ngIf="isTransitionSuccess(transition) === true"
                    xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-green-600 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                  </svg>
                  <svg *ngIf="isTransitionSuccess(transition) === false"
                    xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-red-600 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                  </svg>
                  <!-- Badge de disparador -->
                  <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-amber-100 text-amber-800">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    {{ transition.trigger_event_label }}
                  </span>
                </div>

                <!-- Badges de condiciones y acciones -->
                <div *ngIf="(transition.condition_definitions || transition.conditionDefinitions)?.length > 0 || (transition.action_definitions || transition.actionDefinitions)?.length > 0"
                     class="flex flex-wrap items-center gap-1 mb-2">
                  <span *ngFor="let condition of (transition.condition_definitions || transition.conditionDefinitions || [])"
                        class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                    {{ condition.name }}
                  </span>
                  <span *ngFor="let action of (transition.action_definitions || transition.actionDefinitions || [])"
                        class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                    </svg>
                    {{ getRateNameForAction(transition, action) }}
                  </span>
                </div>

                <!-- Estado siguiente -->
                <div class="flex items-center gap-2 text-sm">
                  <span class="text-gray-600">→ Siguiente estado:</span>
                  <span [ngClass]="getStateColor(transition.to_state?.id)"
                    class="px-2 py-1 rounded font-medium border">
                    {{ transition.to_state?.name }}
                  </span>
                </div>

                <!-- Información adicional -->
                <div class="flex items-center gap-3 mt-2 text-xs text-gray-600">
                  <span *ngIf="transition.is_automatic" class="flex items-center gap-1">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 text-green-600" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                    Automática
                  </span>
                  <span [ngClass]="transition.is_active ? 'text-green-600' : 'text-red-600'" class="flex items-center gap-1">
                    <span class="w-2 h-2 rounded-full" [ngClass]="transition.is_active ? 'bg-green-600' : 'bg-red-600'"></span>
                    {{ transition.is_active ? 'Activa' : 'Inactiva' }}
                  </span>
                </div>
              </div>

              <!-- Acciones -->
              <div class="flex gap-1">
                <button (click)="openEditForm(transition)" class="p-1 hover:bg-gray-100 rounded" title="Editar">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                  </svg>
                </button>
                <button (click)="deleteTransition(transition.id)" class="p-1 hover:bg-gray-100 rounded text-red-600" title="Eliminar">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Estados normales -->
      <div *ngFor="let state of allStates" class="border rounded-lg overflow-hidden">
        <!-- Encabezado del estado -->
        <div 
          [ngClass]="getStateColor(state.id)"
          class="border-b-2 p-3 cursor-pointer hover:opacity-80 transition-opacity"
          (click)="getTransitionsFrom(state.id).length > 0 && toggleExpanded(state.id)">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-2">
              <!-- Icono de expandir/colapsar -->
              <svg *ngIf="getTransitionsFrom(state.id).length > 0 && !expandedStates[state.id]" 
                xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
              </svg>
              <svg *ngIf="getTransitionsFrom(state.id).length > 0 && expandedStates[state.id]" 
                xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
              </svg>
              
              <span class="font-semibold">{{ state.name }}</span>
              
              <!-- Badge con número de transiciones -->
              <span *ngIf="getTransitionsFrom(state.id).length > 0" 
                class="text-xs bg-white px-2 py-1 rounded-full">
                {{ getTransitionsFrom(state.id).length }} transición{{ getTransitionsFrom(state.id).length !== 1 ? 'es' : '' }}
              </span>
            </div>
            <div class="flex gap-2">
              <!-- Aquí podrías agregar botones de acción para el estado -->
            </div>
          </div>
        </div>

        <!-- Transiciones (colapsable) -->
        <div *ngIf="expandedStates[state.id] && getTransitionsFrom(state.id).length > 0"
          class="p-3 bg-gray-50 space-y-2">
          <div *ngFor="let transition of getTransitionsFrom(state.id)"
            class="bg-white border rounded-lg p-3 hover:shadow-sm transition-shadow">
            <div class="flex items-start justify-between gap-3">
              <div class="flex-1">
                <!-- Título con icono de estado -->
                <div class="flex items-center gap-2 mb-2">
                  <svg *ngIf="isTransitionSuccess(transition) === true"
                    xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-green-600 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                  </svg>
                  <svg *ngIf="isTransitionSuccess(transition) === false"
                    xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-red-600 flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                  </svg>
                  <!-- Badge de disparador -->
                  <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-amber-100 text-amber-800">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    {{ transition.trigger_event_label }}
                  </span>
                </div>

                <!-- Badges de condiciones y acciones -->
                <div *ngIf="(transition.condition_definitions || transition.conditionDefinitions)?.length > 0 || (transition.action_definitions || transition.actionDefinitions)?.length > 0"
                     class="flex flex-wrap items-center gap-1 mb-2">
                  <span *ngFor="let condition of (transition.condition_definitions || transition.conditionDefinitions || [])"
                        class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                    </svg>
                    {{ condition.name }}
                  </span>
                  <span *ngFor="let action of (transition.action_definitions || transition.actionDefinitions || [])"
                        class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                    </svg>
                    {{ getRateNameForAction(transition, action) }}
                  </span>
                </div>

                <!-- Estado siguiente -->
                <div class="flex items-center gap-2 text-sm">
                  <span class="text-gray-600">→ Siguiente estado:</span>
                  <span [ngClass]="getStateColor(transition.to_state?.id)"
                    class="px-2 py-1 rounded font-medium border">
                    {{ transition.to_state?.name }}
                  </span>
                </div>

                <!-- Información adicional -->
                <div class="flex items-center gap-3 mt-2 text-xs text-gray-600">
                  <span *ngIf="transition.is_automatic" class="flex items-center gap-1">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3 text-green-600" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                    </svg>
                    Automática
                  </span>
                  <span [ngClass]="transition.is_active ? 'text-green-600' : 'text-red-600'" class="flex items-center gap-1">
                    <span class="w-2 h-2 rounded-full" [ngClass]="transition.is_active ? 'bg-green-600' : 'bg-red-600'"></span>
                    {{ transition.is_active ? 'Activa' : 'Inactiva' }}
                  </span>
                </div>
              </div>

              <!-- Acciones -->
              <div class="flex gap-1">
                <button (click)="openEditForm(transition)" class="p-1 hover:bg-gray-100 rounded" title="Editar">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                  </svg>
                </button>
                <button (click)="deleteTransition(transition.id)" class="p-1 hover:bg-gray-100 rounded text-red-600" title="Eliminar">
                  <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && !error && transitions.length === 0" class="text-center py-12 bg-gray-50 rounded-lg">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 mx-auto text-gray-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
    <h3 class="text-lg font-medium text-gray-900 mb-2">No hay transiciones configuradas</h3>
    <p class="text-gray-600">Este producto no tiene transiciones de estado</p>
  </div>
</div>

<!-- Modal para copiar transiciones -->
<div *ngIf="showCopyModal"
  (click)="closeCopyModal()"
  class="fixed animate-fade-in inset-0 z-50 flex items-center justify-center modal-backdrop p-4 overflow-y-auto">
  <div (click)="$event.stopPropagation()" class="bg-white relative rounded-3xl shadow-2xl w-full max-w-2xl my-8 animate-slide-in-top">
    <!-- Header -->
    <div class="flex items-center justify-between px-8 py-6 border-b border-gray-100">
      <h2 class="text-2xl font-bold text-gray-800">Copiar transiciones desde otro producto</h2>
      <button (click)="closeCopyModal()"
        class="w-10 h-10 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-red-500 transition-all duration-200">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="px-8 py-6 space-y-4">
      <!-- Loading state -->
      <div *ngIf="copyProductsLoading" class="flex items-center gap-3 text-gray-600">
        <span class="inline-block animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></span>
        <span>Cargando productos disponibles...</span>
      </div>

      <!-- Product selector -->
      <div *ngIf="!copyProductsLoading && availableProducts.length > 0" class="space-y-2">
        <label class="block text-sm font-medium text-gray-700" for="copy-product-select">
          Selecciona el producto origen
        </label>
        <app-custom-dropdown
          [(ngModel)]="selectedSourceProductId"
          [options]="availableProducts"
          placeholder="-- Selecciona un producto --"
          [showClear]="true">
        </app-custom-dropdown>
        <p class="text-sm text-gray-500 mt-1">
          Se copiarán todas las transiciones del producto seleccionado al producto actual.
        </p>
      </div>

      <!-- No products available -->
      <div *ngIf="!copyProductsLoading && availableProducts.length === 0" class="bg-yellow-50 text-yellow-800 border border-yellow-200 px-4 py-3 rounded-lg">
        <div class="flex items-start gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mt-0.5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
          </svg>
          <span>No hay otros productos disponibles para copiar transiciones.</span>
        </div>
      </div>

      <!-- Error message -->
      <div *ngIf="copyError" class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
        <div class="flex items-start gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mt-0.5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
          </svg>
          <span>{{ copyError }}</span>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="border-t border-gray-100 px-8 py-6 flex justify-end gap-3">
      <button 
        (click)="closeCopyModal()" 
        class="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors"
        [disabled]="copyLoading"
      >
        Cancelar
      </button>
      <button 
        (click)="confirmCopyTransitions()"
        class="px-4 py-2 rounded-lg bg-primary text-white hover:bg-primary-dark transition-colors flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="copyLoading || !selectedSourceProductId"
      >
        <span *ngIf="copyLoading" class="inline-block animate-spin rounded-full h-4 w-4 border-b-2 border-white"></span>
        <span>{{ copyLoading ? 'Copiando...' : 'Copiar transiciones' }}</span>
      </button>
    </div>
  </div>
</div>

<!-- Modal del formulario -->
<div *ngIf="showForm"
  (click)="closeForm()"
  class="fixed animate-fade-in inset-0 z-50 flex items-center justify-center modal-backdrop p-4 overflow-y-auto">
  <div (click)="$event.stopPropagation()" class="bg-white relative rounded-3xl shadow-2xl w-full max-w-4xl my-8 animate-slide-in-top">
    <!-- Header del modal -->
    <div class="flex items-center justify-between px-8 py-6 border-b border-gray-100">
      <h2 class="text-2xl font-bold text-gray-800">{{ transitionForm?.formTitle }}</h2>
      <button (click)="closeForm()"
        class="w-10 h-10 flex items-center justify-center rounded-full text-gray-400 hover:text-white hover:bg-red-500 transition-all duration-200">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>

    <!-- Contenido del formulario -->
    <div class="px-8 py-6">
      <app-generic-form
        *ngIf="transitionForm"
        [genericForm]="transitionForm"
        [selectedItem]="selectedTransition"
        [showCancel]="true"
        (onCancel)="closeForm()"
        (onFinished)="onFormFinished()">
      </app-generic-form>
    </div>
  </div>
</div>

<!-- Modal de confirmación de eliminación -->
<app-confirmation 
  *ngIf="showDeleteConfirmation" 
  [visible]="showDeleteConfirmation"
  question="¿Desea eliminar esta transición?"
  confirmText="Sí, eliminar" 
  cancelText="No, cancelar"
  (confirm)="confirmDelete()" 
  (cancel)="cancelDelete()">
</app-confirmation>